const FEMININE = new Set([
  'juventus', 'roma', 'lazio', 'fiorentina', 'cremonese', 'salernitana', 'sampdoria',
  'reggiana', 'ternana', 'carrarese', 'juve stabia', 'triestina', 'pistoiese', 'spal',
]);

export const cleanTeamName = (name = '') =>
  name.replace(/^(AS|AC|SSC|US|FC|SS|SSD|ACF|UC)\s+/i, '').replace(/^Hellas\s+/i, '').trim();

// "del Milan", "della Roma", "dell'Atalanta", "dello Spezia"
export const withArticle = (name) => {
  const n = cleanTeamName(name);
  const low = n.toLowerCase();
  if (/^[aeiouhàèéìòù]/i.test(n)) return `dell'${n}`;
  if (low === 'spezia') return `dello ${n}`;
  if (FEMININE.has(low)) return `della ${n}`;
  return `del ${n}`;
};

const WEEKDAYS = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];

export const alertsTitle = (team, match) => {
  if (!team) return 'Vuoi sapere quando escono le analisi e quando vanno a segno?';
  if (match?.match_date && !match.is_live) {
    const day = WEEKDAYS[new Date(`${match.match_date}T12:00:00`).getDay()];
    const time = (match.match_time || '').slice(0, 5);
    return `${cleanTeamName(match.home_team)}–${cleanTeamName(match.away_team)}, ${day}${time ? ` ${time}` : ''}: ti avvisiamo appena esce l'analisi`;
  }
  return `Ti avvisiamo appena esce l'analisi della prossima partita ${withArticle(team.name)}`;
};

export const alertsSubtitle = (needsEmail, needsPush, reconfirm = false, team = null) => {
  if (reconfirm && needsEmail && !needsPush) {
    return team
      ? `Ricevi via email le analisi ${withArticle(team.name)} appena escono e tutte le novità di RVincente. Puoi disattivarle quando vuoi dal Profilo.`
      : 'Ricevi via email le nuove analisi e tutte le novità di RVincente. Puoi disattivarle quando vuoi dal Profilo.';
  }
  if (needsEmail && needsPush) return 'Ti avviseremo con una notifica e via email. Puoi disattivarli quando vuoi dal Profilo.';
  if (needsPush) return 'Ti avviseremo con una notifica. Puoi disattivarle quando vuoi.';
  return 'Ti avviseremo via email. Puoi disattivarle quando vuoi dal Profilo.';
};

export const previewText = (team, match) => {
  if (match?.home_team) return `📊 È uscita l'analisi di ${cleanTeamName(match.home_team)}–${cleanTeamName(match.away_team)}`;
  if (team) return `📊 È uscita l'analisi della partita ${withArticle(team.name)}`;
  return "📊 È uscita l'analisi di Napoli–Inter";
};
